import { DynamicField, DynamicForm, FieldVariant, SelectFieldProps, SelectOption } from '@/components/form-builder/form-builder.types';
import { TranslateService } from '@ngx-translate/core';
import { DacScenariosRepository } from '@/store/dac-scenarios-state/dac-scenarios-state.repository';
import { map, of } from 'rxjs';

interface IModeEvaluationFinalFormObjectProps {
  store: DacScenariosRepository;
  translate: TranslateService;
}

export function modeEvaluationFinalFormObject({ store, translate }: IModeEvaluationFinalFormObjectProps): DynamicForm {
  
  const field: DynamicField<SelectFieldProps> = {
    label: translate.instant('settings.dacScenarios.form.modeEvaluationFinal.label'),
    variant: FieldVariant.SELECT,
    isRequired: true,
    isDisabled: store.getObservable<SelectOption[]>('modeEvaluationFinalOptions').pipe(
      map(options => !options || options.length === 0)
    ),
    props: {
      placeholder: translate.instant('settings.dacScenarios.edit.modeEvaluationFinal.selectMode'),
      options: store.getObservable<SelectOption[]>('modeEvaluationFinalOptions'),
      value: store.getNestedObservable('dto', 'modeEvaluationFinalId').pipe(
        map(id => {
          const options = store.get<SelectOption[]>('modeEvaluationFinalOptions') || [];
          return options.find(opt => opt.code === id) || undefined;
        })
      ),
      onSelectChange: (selected: SelectOption) => {
        store.setNested('dto', 'modeEvaluationFinalId', selected?.code as number || null);
      },
    },
  };

  return {
    title: '',
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [field],
          }
        ],
      },
    ],
  };
}
